export const environment = {
  production: true,
  apiUrl:
    "https://can-main-webapp-d-djb7bcb9dgajdbde.canadacentral-01.azurewebsites.net/api",
  baseUrl:
    "https://can-main-webapp-d-djb7bcb9dgajdbde.canadacentral-01.azurewebsites.net",
  notifUrl:
    "wss:/can-main-webapp-d-djb7bcb9dgajdbde.canadacentral-01.azurewebsites.net/ws/",
  imageBaseUrl: "static/gloget/assets/img",
  assetBaseUrl: "static/gloget/assets/",
  squareAppId: "sandbox-sq0idb-9coiImLEZsSlSJK9x-rfSQ",
  // Location ID is resolved dynamically from the backend's Square
  // connection (SquareLocationMapping) — not hardcoded.
  // TODO (M3): Replace with the production Square App ID and set
  // squareUseSandbox to false once production credentials are available.
  squareLocationId: "Toronto",
  squareUseSandbox: true,
};
